var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6 16.95C21.4 18 20.55 18.8 19.5 18.95C17.85 19.2 15.1 19.5 12 19.5C8.95 19.5 6.2 19.2 4.5 18.95C3.45 18.8 2.6 18 2.4 16.95C2.2 15.8 2 14.1 2 12C2 9.9 2.2 8.2 2.4 7.05C2.6 6 3.45 5.2 4.5 5.05C6.15 4.8 8.9 4.5 12 4.5C15.1 4.5 17.8 4.8 19.5 5.05C20.55 5.2 21.4 6 21.6 7.05C21.8 8.2 22.05 9.9 22.05 12C22 14.1 21.8 15.8 21.6 16.95Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 15.5V8.5L16 12L10 15.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsYoutube);
export default __webpack_public_path__ + "static/media/WHSYoutube.bee8699b110789760b076d7d346ec0d3.svg";
export { ForwardRef as ReactComponent };